import React from 'react';

import currencyUtils from 'utils/currency';
import Aux from '../../../../../hoc/ReactAux/ReactAux';
import NutritionFacts from '../ProductDetails/NutritionFacts';

export const product = props => {
  let currency = '€';
  if (!!props.business) {
    currency = currencyUtils.convertNameToSymbol(props.business.currency);
  }

  return (
    props.business != null && (
      <Aux key={props.product.id}>
        <a
          onClick={() => props.selectProduct(props.product.id)}
          className={
            props.business.isOpen
              ? 'modal-a popup-with-zoom-anim'
              : 'modal-a popup-with-zoom-anim menu-inactive'
          }
          disabled={!!!props.business.isOpen}
          id="orders-items"
          role="button"
          aria-label={`Selecionar ${props.product.name} por ${currency +
            props.product.price.toFixed(2)}`}
        >
          <article>
            <header>
              <h3 style={{ width: '85%', fontSize: '14px' }}>
                {props.product.name}
                {props.isPopularDish ? (
                  <p className="restaurant-name-home block fr">
                    {' '}
                    BY {props.business.name}{' '}
                  </p>
                ) : null}
              </h3>
              <p>{currency + props.product.price.toFixed(2)}</p>
            </header>
            <NutritionFacts product={props.product}></NutritionFacts>
            <p className="product-description">{props.product.description}</p>
          </article>
        </a>
      </Aux>
    )
  );
};

export default product;



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Products/Product/index.js